import React from "react";
import { WeeklyListsFilter } from "./WeeklyListsFilter";
import "../Search.css";
import { Grid, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { SearchHelper } from "../SearchHelper";
import { Dayjs } from "dayjs";
import datePickerValueFormatter from "@mirage/components/helpers/datePickerValueFormatter";

interface WeeklyListsSimpleSearchProps {
    state: WeeklyListsFilter;
    setter: (modifier: Partial<WeeklyListsFilter>) => void;
}

const WeeklyListsSimpleSearch: React.FC<WeeklyListsSimpleSearchProps> = (props) => {
    return (
        <Grid container className="search-container search-container-simple">
            <Grid item xs={12} md={12} xl={12}>
                <Typography variant="h5">Reference</Typography>
            </Grid>
            <Grid item xs={12} md={12} xl={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs} key="weekly-list-date-created-from">
                    <DatePicker
                        value={datePickerValueFormatter(props.state.dateCreatedFrom)}
                        onChange={(value: Dayjs | null) => props.setter({ dateCreatedFrom: value?.toDate() })}
                        label="Date Created From"
                        className="min-width-18rem"
                        slotProps={{ textField: { ...SearchHelper.dateInputProps("weekly-list-date-created-from") } }}
                    />
                </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={12} xl={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs} key="weekly-list-date-created-to">
                    <DatePicker
                        value={datePickerValueFormatter(props.state.dateCreatedTo)}
                        onChange={(value: Dayjs | null) => props.setter({ dateCreatedTo: value?.toDate() })}
                        slotProps={{ textField: { ...SearchHelper.dateInputProps("weekly-list-date-created-to") } }}
                        label="Date Created To"
                        className="min-width-18rem"
                    />
                </LocalizationProvider>
            </Grid>
        </Grid>
    );
};

export default WeeklyListsSimpleSearch;
